import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Card, Column, Typography } from 'seagull';
import styles from './IntegrationCard.module.scss';
export default function IntegrationCard(props) {
    const { testId, icon, title, subTitle, mainAction, disclaimer } = props;
    return /*#__PURE__*/ _jsxs(Card, {
        bi: {
            name: 'integration_card',
            data: {
                test_id: testId !== null && testId !== void 0 ? testId : ''
            }
        },
        testId: testId,
        className: styles.card,
        children: [
            /*#__PURE__*/ _jsxs(Column, {
                gap: 12,
                alignItems: "start",
                children: [
                    icon,
                    /*#__PURE__*/ _jsxs(Column, {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                weight: "normal",
                                children: title
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                testId: testId && "".concat(testId, "-sub-title"),
                                variant: 'paragraph2',
                                skin: "secondary",
                                children: subTitle
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Column, {
                className: styles.bottom,
                alignItems: "start",
                justifyContent: "space-between",
                children: [
                    mainAction,
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: 'paragraph3',
                        skin: "secondary",
                        children: disclaimer || ' '
                    })
                ]
            })
        ]
    });
}
IntegrationCard.MainActionButton = (props)=>/*#__PURE__*/ _jsx(Button, _object_spread({
        size: "small"
    }, props));
